import { Modal, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const ConfirmDeleteModal = (props) => {
  const { handleDelete } = props;

  return (
    <Modal {...props}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="CONFIRM.DELETE.TITLE" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id="CONFIRM.DELETE.BODY" />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          <FormattedMessage id="AUTH.GENERAL.CANCEL_BUTTON" />
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          <FormattedMessage id="AUTH.GENERAL.DELETE_BUTTON" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
